export const initialState = {
    synapseRoomId: "",
    showChat: false,
    synapseEvents: null,
    unreadMessageCount: null,
    roomMessages: [],
    roomMembers: [],
    matrixClient: null,
    matrixServer: null,
    joinedRooms: [],
    selectedRoom: null,
    accordionToggleState: '',
    selectedFile: '',
    selectedImageUrl: ''
}

export const ChatReducer = (state = initialState, action) => {
    console.log('=== ChatReducer Debug ===');
    console.log('Action type:', action.type);
    console.log('Action payload:', action.payload);
    console.log('Current state showChat:', state.showChat);
    console.log('Current state synapseRoomId:', state.synapseRoomId);
    
    switch(action.type){
        case 'matrixAuthError': {
            console.log('Matrix authentication error:', action.payload);
            return {
                ...state,
                matrixAuthError: action.payload,
            };
        }
        case 'setSynapseRoomID': {
            console.log('Setting synapseRoomId to:', action.payload);
            return {
                ...state,
                synapseRoomId: action.payload,
            };
        }
        case 'showChat': {
            console.log('Setting showChat to: true');
            return {
                ...state,
                showChat: true,
            };
        }
        case 'hideChat': {
            return {
                ...state,
                showChat: false,
            };
        }
        case 'setSynapseEvents': {
            return {
                ...state,
                synapseEvents: action.payload,
            };
        }
        case 'addSynapseEvents': {
            // Ensure we don't create nested arrays and handle null state
            const currentEvents = state.synapseEvents || [];
            const newEvents = Array.isArray(action.payload) ? action.payload : [action.payload];
            
            // Filter out duplicates based on event_id
            const existingEventIds = new Set(currentEvents.map(event => event.event_id));
            const uniqueNewEvents = newEvents.filter(event => event.event_id && !existingEventIds.has(event.event_id));
            
            return {
                ...state,
                synapseEvents: [...currentEvents, ...uniqueNewEvents],
            };
        }
        case 'setUnreadMessageCount': {
            return {
                ...state,
                unreadMessageCount: action.payload,
            };
        }        
        case 'setRoomMembers':{
            return {
                ...state,
                roomMembers: [...state.roomMembers , action.payload],
            }
        }
        case 'setMatrixClient': {
            return {
                ...state,
                matrixClient: action.payload,
            }
        }
        case 'setMatrixServer': {
            return {
                ...state,
                matrixServer: action.payload,
            }
        }
        case 'setJoinedRooms': {
            return {
                ...state,
                joinedRooms: action.payload,
            }
        }
        case 'setSelectedChatRoom': {
            return {
                ...state,
                selectedRoom: action.payload,
            }
        }
        case 'logout': {
            return {
                synapseRoomId: "",
                showChat: false,
                synapseEvents: null,
                unreadMessageCount: null,
                roomMessages: [],
                roomMembers: [],
                matrixClient: null,
                joinedRooms: null,
                selectedRoom: null,
                selectedFile: null,
            }
        }
        // eslint-disable-next-line
        case 'setRoomMembers':{
            return {
                ...state,
                roomMembers: [...state.roomMembers , action.payload],
            }
        }
        // eslint-disable-next-line
        case 'setMatrixClient': {
            return {
                ...state,
                matrixClient: action.payload,
            }
        }
        // eslint-disable-next-line
        case 'setJoinedRooms': {
            return {
                ...state,
                joinedRooms: action.payload,
            }
        }
        // eslint-disable-next-line
        case 'setSelectedChatRoom': {
            return {
                ...state,
                selectedRoom: action.payload,
            }
        }
        case 'setAccordionToggleState':{
            return {
                ...state,
                accordionToggleState: action.payload,
            }
        }
        // eslint-disable-next-line
       case 'setSelectedFile':{
            return {
                ...state,
                selectedFile: action.payload,
            }
       }
       // eslint-disable-next-line
       case 'setSelectedImageUrl':{
            return {
                ...state,
                selectedFile: action.payload,
            }
       }
        default: 
            return state
    }
}